import api from '../../config/axios.js';

const state = {
    productsList: [],
    productCatalogList: [],
    productsSearchList: [],
    productCatalogPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
    productsPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
    currentDeleteProduct: {},
    currentUpdateProduct: {}
}

const getters = {
    getProductsList: state => state.productsList,
    getProductCatalogList: state => state.productCatalogList,
    getProductsSearchList: state => state.productsSearchList,
    getProductCatalogPagination: state => state.productCatalogPagination,
    getProductsPagination: state => state.productsPagination,
    getCurrentDeleteProduct: state => state.currentDeleteProduct,
    getCurrentUpdateProduct: state => state.currentUpdateProduct
}

const actions = {
    async setProductCatalogList({ commit }, page = 1){
        await api.axios.get(`/api/products?page=${page}`).catch(() => {
            commit("setProductCatalogList", []);
            commit("setProductCatalogPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data.filter(Boolean) : (Array.isArray(payload) ? payload.filter(Boolean) : []);
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("setProductCatalogList", list);
                commit("setProductCatalogPagination", pagination);
            }
        });
    },
    // LISTANDO PRODUTOS
    async setProductsList({ commit }, page = 1){
        await api.axios.get(`/api/products?page=${page}`).catch(() => {
            commit("setProductsList", []);
            commit("setProductsPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data.filter(Boolean) : (Array.isArray(payload) ? payload.filter(Boolean) : []);
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("setProductsList", list);
                commit("setProductsPagination", pagination);
            }
        });
    },
    async setProductsSearchList({ commit }, search){
        if(!search || search.length < 2){
            commit("setProductsSearchList", []);
            return;
        }

        await api.axios.get(`/api/products/search/${encodeURIComponent(search)}`).catch(() => {
            commit("setProductsSearchList", []);
        }).then((response) => {
            if(response && response.data){
                commit("setProductsSearchList", response.data);
            }
        });
    },
    async setCurrentDeleteProduct({ commit }, data){
        commit('setCurrentDeleteProduct', data);
    },
    async setCurrentUpdateProduct({ commit }, data){
        commit('setCurrentUpdateProduct', data);
    }
}

const mutations = {
    setProductsList: function(state, data){
        state.productsList = data;
    },
    setProductCatalogList: function(state, data){
        state.productCatalogList = data;
    },
    setProductsSearchList: function(state, data){
        state.productsSearchList = data;
    },
    setProductCatalogPagination: function(state, data){
        state.productCatalogPagination = data;
    },
    setProductsPagination: function(state, data){
        state.productsPagination = data;
    },
    setCurrentDeleteProduct: function(state, data){
        state.currentDeleteProduct = data;
    },
    setCurrentUpdateProduct: function(state, data){
        state.currentUpdateProduct = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
